import React, { Component } from 'react';

// Elements
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import SectionHeading from '../SectionHeading/SectionHeading';

export default class Header extends Component {

    render() {
        if(this.props.clinic.treatments.length === 0) {
            return <></>
        }
        return (
        <div className="space-medium" id='treatments'>
            <Container>
                <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                        <SectionHeading title="Our Services"/>
                    </Col>
                </Row>
                <Row>
                    {(this.props.clinic.overrides.service_card != "full-image")?
                    (this.props.clinic.treatments.map(service =>(
                    <Col lg={4} md={6} sm={6} xs={12} key={service.id}>
                        <div className="service-block-v2 wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.3s"
                            style={{background:this.props.clinic.theme.overrides.card_background_colour}}>
                            <a href={service.url?service.url:`/treatments/${service.id}`}>
                                <div className="service-icon" >
                                    {service.icon?
                                    <i className={service.icon}></i>
                                    :<img alt={service.name} src={service.icon_path} className='treatment icon'/>}
                                </div>
                                <h3>{service.name}</h3>
                                <p>{service.about_short}</p>
                            </a>
                        </div>
                    </Col>))):
                    (this.props.clinic.treatments.map(service =>(
                    <Col lg={4} md={6} sm={6} xs={12} key={service.id}>
                        <div className="service-block-full-image wow fadeInUp" data-wow-duration="1.3s" data-wow-delay="0.3s">
                            <a href={service.url?service.url:`/treatments/${service.id}`}>
                                <img alt={service.name} src={service.icon_path} className='w-100'/>
                            </a>
                        </div>
                    </Col>)))
                    }
                </Row>
            </Container>
        </div>
        );
    }
}